import React, { useCallback, useEffect, useState } from 'react';
import { SafeAreaView, StyleSheet, View, Text } from 'react-native';
import _ from 'lodash';
import { Icon, Avatar } from 'react-native-elements';
// import { Agenda } from 'react-native-calendars';
import moment from 'moment';
import Agenda from '../../components/ZoneAgenda/ZoneAgenda';

import SearchBar from '../../components/SearchBar';
import { getCommunityCalendarAPI } from '../../api/adserver';

type Props = {};

const CommunityAgendaScreen: React.FC<Props> = ({ navigation, route }: any) => {
  const { selected, events } = route.params;
  const [items, setItems] = useState({});

  const renderItem = (item: any, firstInDay: any) => {
    const avatarTitle = item.name
      .split(/\s/)
      .splice(0, 2)
      .reduce((response: any, word: any) => (response += word.slice(0, 1)), '');

    return (
      <View style={[styles.item]}>
        <View style={styles.itemLeft}>
          <Text style={styles.itemTime}>
            {moment(item.start_date_time).format('hh:mm A')} -{' '}
            {moment(item.stop_date_time).format('hh:mm A')}
          </Text>
          <Text style={styles.itemName}>{item.name}</Text>
          <Text style={styles.subTitle}>{item.headline}</Text>
        </View>
        <View style={styles.itemRight}>
          <Avatar rounded title={avatarTitle} activeOpacity={0.7} />
        </View>
      </View>
    );
  };

  const loadItems = useCallback(
    (month: any) => {
      let groupedItems = _.groupBy(events, (i) =>
        moment(i.start_date_time).format('YYYY-MM-DD'),
      );
      setItems(groupedItems);
    },
    [events],
  );

  const getMarkedDates = useCallback(() => {
    let dates: any = {};

    events?.forEach((item: any) => {
      dates[moment(item.start_date_time).format('YYYY-MM-DD')] = {
        marked: true,
      };
    });

    return dates;
  }, [events]);

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.searchWrapper}>
        <Icon
          name="arrow-back"
          size={30}
          color="#ffffff"
          onPress={navigation.goBack}
          tvParallaxProperties={null}
        />
        <View style={styles.searchBar}>
          <SearchBar placeholder="Search" />
        </View>
      </View>
      <View style={[styles.scrollView]}>
        <Agenda
          items={items}
          loadItemsForMonth={loadItems}
          selected={selected}
          renderItem={renderItem}
          renderEmptyData={() => {
            return (
              <View>
                <Text style={styles.informationText}>
                  There are no events for this day
                </Text>
              </View>
            );
          }}
          rowHasChanged={(item1: any, item2: any) => item1.id !== item2.id}
          markedDates={getMarkedDates()}
        />
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#333333',
    flex: 1,
  },
  scrollView: {
    backgroundColor: '#f7f7f7',
    height: '100%',
  },

  searchWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#333333',
    paddingStart: 10,
  },
  searchBar: {
    flex: 1,
  },
  item: {
    backgroundColor: 'white',
    flex: 1,
    borderRadius: 2,
    padding: 10,
    marginRight: 10,
    marginTop: 17,
    flexDirection: 'row',
  },
  itemLeft: {
    flex: 1,
  },
  itemRight: {
    paddingLeft: 10,
  },
  itemTime: {
    fontSize: 12,
    marginBottom: 4,
  },
  itemName: {
    marginBottom: 4,
  },
  subTitle: {
    fontSize: 10,
    color: 'gray',
  },
  informationText: {
    fontSize: 12,
    color: 'gray',
    textAlign: 'center',
    marginVertical: 20,
  },
});

export default CommunityAgendaScreen;
